import { getAntiforgeryToken } from "../api/http";

// Error Hub en el navegador (igual que client-errors.js del portal actual): solo errores propios del navegador, con los
// mismos códigos (BROWSER_UNHANDLED, BROWSER_PROMISE_REJECTION) y el mismo destino (/telemetry/client-errors del
// servidor del portal, que los manda al Error Hub). Sin DOM, capturas ni actividad continua; a lo más 10 por página.
let sent = 0;
let reporting = false;

export function reportClientError(errorKey: string, message: unknown, stack?: unknown): void {
  const token = getAntiforgeryToken();
  if (reporting || sent >= 10 || !token) return;
  sent++;
  reporting = true;
  fetch("/telemetry/client-errors", {
    method: "POST",
    credentials: "same-origin",
    keepalive: true,
    headers: { "Content-Type": "application/json", "X-CSRF-TOKEN": token },
    body: JSON.stringify({
      errorKey,
      message: String(message || "Client error").slice(0, 8000),
      stack: String(stack || "").slice(0, 16000),
      route: location.pathname,
      browser: navigator.userAgent,
      locale: navigator.language,
      viewport: `${innerWidth}x${innerHeight}`,
    }),
  })
    .catch(() => undefined) // Telemetría perdida; el flujo funcional sigue intacto.
    .finally(() => {
      reporting = false;
    });
}

/** Escucha los errores no manejados de la página (una vez). */
export function installClientErrors(): void {
  window.addEventListener("error", (event) =>
    reportClientError("BROWSER_UNHANDLED", event.message, event.error?.stack),
  );
  window.addEventListener("unhandledrejection", (event) =>
    reportClientError("BROWSER_PROMISE_REJECTION", event.reason?.message ?? event.reason, event.reason?.stack),
  );
}
